import React from 'react';
import ReactDOMServer from "react-dom/server";
import { locHtml } from "../locHtml";

const invitationComfortFollow = (t: (key: string) => string) => <div className="new-quote-container centered">
  <div className="splash-header">
    <h1 className="no-word-break">{t("splash.gymBuddy.invitationComfortFollow.title")}</h1>
    <div className="quote">
      {t("splash.gymBuddy.invitationComfortFollow.text")}
    </div>
  </div>
</div>;

const invitationComfortFollowElement = {
  name: 'invitation-comfort-follow',
  type: 'html',
  html: locHtml((t) => ReactDOMServer.renderToStaticMarkup(invitationComfortFollow(t))),
  visibleIf: `{invitationcomfort} == "No"`
}

export default invitationComfortFollowElement;
